import { ARCHIVE_MENU_CONFIG, MENU_CONFIG } from "../config/menu.config";
export const menu = MENU_CONFIG;



// WEBPACK FOOTER //
// ./src/app/routes/menu.ts